import React, {useEffect, useState} from "react";
import Button from "antd-button-color"; //npm install antd-button-color  || https://www.npmjs.com/package/antd-button-color
import { Typography, DatePicker, Modal, Table, Form, TreeSelect, Row, Col, Input, Badge,Tag} from "antd";
import {
    errorHandle,
    getDaysArray, openNotificationWithIcon,
} from "../../Function";
import moment from "moment";
import ListTeamApi, { ListBoPhanApi } from "../../../api/getListTeam";
import {dieuChinhPhepCaNhanApi, duyetPhepTeamApi, ListBangPhepQLApi} from "../../../api/getListBangPhep";
import { useSelector } from "react-redux";

const { Text, Link } = Typography;

const validateMessages = {
	required: '${label} là bắt buộc.',
	types: {
	},
	number: {
	},
};

const ModalKhaiBaoPhep =({visible, onCancel, updateData})=>{
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const onFinish = (values) => {
        // dieuChinhPhepCaNhanApi({
        //     UserId: dataDieuChinh.userId,
        //     thoiGian: values.date.format("YYYYMM"),
        //     dieuchinh: values.edit,
        //     ghichu: values.note
        // })
        //     .then(r=>{
        //         updateData();
        //         openNotificationWithIcon('success','Thành công','')
        //         onCancel();
        //     })
        //     .catch(err=>{
        //         errorHandle(err)
        //     })

    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
//
// const tPropsConfig = {
//         treeData:[{
//             title:
//               currentTeam.length > 0 ? (
//                 <span
//                   onClick={() => {setCurrentTeam([]);onChangeTeam([])}}
//                   className="style_SelectTeam"
//                 >
//                   Bỏ chọn tất cả
//                 </span>
//               ) : (
//                 <span
//                   onClick={() => {setCurrentTeam(lsTeam.map(item=>item.id));onChangeTeam(lsTeam.map(item=>item.id))}}
//                   className="style_SelectTeam"
//                 >
//                   Chọn tất cả
//                 </span>
//               ),
//             value: "xxx",
//             disableCheckbox: true,
//             disabled: true,
//             className: "style_treeTeam"
//           },...treeData],
//         value: currentTeam,
//           onChange:onChangeTeam,
//         treeCheckable: true,
//         // showCheckedStrategy: SHOW_PARENT,
//           maxTagCount:2,
//         placeholder: 'Chọn team',
//         style:{width:'fit-content',minWidth:200},
//       };

    return (
        <Modal title={"Khai báo phép"} visible={visible} onCancel={onCancel} footer={false}>
             <Form
                form={form}
                name="basic"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                validateMessages={validateMessages}
            >
                <Row >
                    {/*<Col span={24}>*/}
                    {/*    <Form.Item*/}
                    {/*        label="Tên nhân viên"*/}
                    {/*        name="username"*/}
                    {/*    >*/}
                    {/*        <TreeSelect {...tPropsConfig} />*/}
                    {/*    </Form.Item>*/}
                    {/*</Col>*/}
                    <Col span={24}>
                        <Form.Item
                            label="Điều chỉnh"
                            name="edit"
                            rules={[{ required: true }]}
                        >
                            <Input maxLength={100}/>
                        </Form.Item>
                    </Col>
                    {/*<Col span={24}>*/}
                    {/*    <Form.Item*/}
                    {/*        label="Ghi chú"*/}
                    {/*        name="note"*/}
                    {/*        rules={[{ required: true }]}*/}
                    {/*    >*/}
                    {/*        <Input maxLength={300}/>*/}
                    {/*    </Form.Item>*/}
                    {/*</Col>*/}
                </Row>

                <Row gutter={16}>
                    <Col offset={9}>
                        <Form.Item >
                            <Button type="success" htmlType="submit" className={'m-2'} disabled={loading}>Thêm</Button>
                            <Button onClick={onCancel}>Thoát</Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    )
}

function disabledMonth(current) {
    // Can not select days after today and today
    const currentDate = new Date();
    return current && current > moment(new Date(currentDate.getFullYear(),currentDate.getMonth()),0).endOf('day');
  }


const ModalEditPhep =({visible, onCancel, updateData, dataDetailPhep})=>{
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    useEffect(()=>{
        form.resetFields();
        if (visible) {
            form.setFieldsValue({
                date: moment(dataDetailPhep.strMonth,"MMYYYY"),
                edit: dataDetailPhep["dieuchinh" + dataDetailPhep.strMonth],
                note: dataDetailPhep.ghichu
            });

        };
    },[visible]);

    const onFinish = (values) => {
        dieuChinhPhepCaNhanApi({
            // UserId: dataDetailPhep.userId,
            id: dataDetailPhep["id" + dataDetailPhep.strMonth],
            dieuchinh: values.edit,
            ghichu: values.note
        })
            .then(r=>{
                updateData();
                openNotificationWithIcon('success','Thành công','')
                onCancel();
            })
            .catch(err=>{
                errorHandle(err)
            })

    };
    
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
        
    };



    return (
        <Modal title={"Điều chỉnh ngày phép"} visible={visible} onCancel={onCancel} footer={false} width={800}>
             <Form
                form={form}
                name="basic"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                validateMessages={validateMessages}
            >
                <Row >
                    <Col span={24}>
                        <Form.Item
                            label="Tên nhân viên"
                            name="username"
                        >
                            <Text strong>{dataDetailPhep.username}</Text>
                        </Form.Item>
                    </Col>
                    <Col span={9}>
                        <Form.Item
                            label="Thời gian"
                            name="date"
                            rules={[{ required: true }]}
                        >
                            <DatePicker  format={'MM/YYYY'} allowClear={false} disabled/>
                        </Form.Item>
                    </Col>
                    <Col span={7}>
                        <Form.Item
                            label="Điều chỉnh"
                            name="edit"
                            rules={[{ required: true }]}
                        >
                            <Input maxLength={100}/>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label="Ghi chú"
                            name="note"
                            rules={[{ required: true }]}
                        >
                            <Input maxLength={300}/>
                        </Form.Item>
                    </Col>
                </Row>
             
                <Row gutter={16}>
                    <Col offset={9}>
                        <Form.Item >
                            <Button type="success" htmlType="submit" className={'m-2'} disabled={loading}>Thêm</Button>
                            <Button onClick={onCancel}>Thoát</Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    )
}


export const BangPhep_QL =()=> {
    const defaultPageSize = 50;
    const [pager, setPager] = useState({pageSize:defaultPageSize, count: 0, current:1});
    const [data, setData] = useState([]);
    const [lsTeam, setLsTeam] = useState([]);
    const [columnFinal, setColumnFinal] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState('');
    const [treeData,setTreeData] = useState([]);
    const [currentTeam, setCurrentTeam] = useState([]);
    const [currentSelectedDate, setCurrentSelectedDate] = useState(moment(new Date()));
    const [isShowEditPhep, setIsShowEditPhep] = useState(false);
    const [isShowKhaiBaoPhep, setIsShowKhaiBaoPhep] = useState(false);
    const [dataDetailPhep, setDataDetailPhep] = useState([]);
    const userInfo = useSelector((state)=>state.getUserInfo.userInfo);
    
    const [lsBoPhan, setLsBoPhan] = useState([]);
    const [currentBoPhan, setCurrentBoPhan] = useState([]);
    const [treeDataBoPhan,setTreeDataBoPhan] = useState([]);
    const [lsAllTeam, setLsAllTeam] = useState([]);

    const columns_first =(date)=> {

        return (
            [
                // {
                //     title: "STT",
                //     dataIndex: "index",
                //     key: "index",
                //     render: (value, item, index) => ((pager.current || 1) - 1) * pager.pageSize + index + 1,
                //     sortDirections: ['descend', 'ascend', 'descend'],
                // },
                {
                    title: "Nhân viên",
                    dataIndex: "username",
                    key: "username",
                    align: 'center',
                    className:'highlight',
                    filterKey: 'username',
                    type: 'text',
                    width: 160,
                    canSearch: true,
                    // render: (value, record) => record.msnv + '-' + value,
                
                },
                {
                    title: "Phép cũ " + moment(new Date(date)).subtract(1, 'year').format("YYYY"),
                    dataIndex: "phepcu",
                    key: "phepcu",
                    align: 'center',
                    filterKey: 'phepcu',
                    className:'highlight',
                    type: 'text',
                    width: 80,
                    canSearch: true
                },
                {
                    title: "Thâm niên",
                    dataIndex: "thamnien",
                    key: "thamnien",
                    align: 'center',
                    className:'highlight',
                    width: 80,
                    filterKey: 'thamnien',
                    type: 'text',
                    canSearch: true
                },
                {
                    title: "Phép năm",
                    dataIndex: "phepnam",
                    key: "phepnam",
                    align: 'center',
                    width: 80,
                    className:'highlight',
                    filterKey: 'phepnam',
                    type: 'text',
                    canSearch: true
                },

            ])
    }

    const columns_last = [
        {
            title: "Ghi chú",
            dataIndex: "ghichu",
            key: "ghichu",
            align:'center',
            filterKey: 'ghichu',
            type: 'text',
            className:'highlight',
            width: 300,
            canSearch: true
        },
        {
            title: "Trạng thái",
            dataIndex: "trangthai",
            key: "trangthai",
            className:'lastColumn highlight',
            align:'center',
            filterKey: 'trangthai',
            type: 'text',
            width:100,
            canSearch: true,
            render:(text, record) => {
                if (record["statusid"+currentSelectedDate.format("MMYYYY")] == 0) {
                    return (
                        <Tag color="#FFFBE6" key={0} 
                            style={{color: "#FBB458", fontWeight:'600',borderRadius: 10, border:`1px solid #FBB458`}}
                        >
                            {text}
                        </Tag>
                    )
                } else {
                    return (
                        <Tag color="#F6FFED" key={1} 
                            style={{color: "#77C9A3", fontWeight:'600',borderRadius: 10,border:`1px solid #77C9A3`}}
                        >
                            {text}
                        </Tag>
                    )
                }
            }
        }
      
    ]
    
    // const handleCellDieuChinh = (text, record, strMonth, setIsShowEditPhep, setDataDetailPhep) => {
    //     if (record["statusid"+strMonth] == 0) {
    //         record["strMonth"] = strMonth;
    //         setDataDetailPhep(record);
    //         return (
    //             <>
    //                 <div style={{textAlign:'center',width:'100%'}}>
    //                 {text} <EditOutlined onClick={()=>setIsShowEditPhep(true)}/>
    //                 </div> 
    //             </>
    //         )
    //     } else {
    //         return (
    //             <>
    //                 <div style={{textAlign:'center',width:'100%'}}>
    //                     {text}
    //                 </div> 
    //             </>
    //         )
    //     }
    // };

    const columnsMonth = (date)=>{
        const lsMonth = [moment(new Date(date)).subtract(1,'month').format("MM/YYYY"), date.format("MM/YYYY")];
        let result = [];
        for (let month of lsMonth){
            let obj = {};
            obj.title = month;
            const strMonth = month.replace('/','');
            obj.children = [
                {
                    title: "Cấp",
                    dataIndex: "cap" + strMonth,
                    key: "cap" + strMonth,
                    className:'hoverBlur',
                    align:'center',
                    filterKey: 'cap' + strMonth,
                    type: 'text',
                    width:80,
                },
                {
                    title: "Dùng",
                    dataIndex: "dung" + strMonth,
                    key: "dung" + strMonth,
                    className:'hoverBlur',
                    align:'center',
                    filterKey: 'dung' + strMonth,
                    type: 'text',
                    width:80,
                },
                {
                    title: "Điều chỉnh",
                    dataIndex: "dieuchinh" + strMonth,
                    key: "dieuchinh" + strMonth,
                    className:'hoverBlur',
                    align:'center',
                    filterKey: 'dieuchinh' + strMonth,
                    type: 'text',
                    width:90,
                    // render:(text, record) =>month !== lsMonth[1] ? text : handleCellDieuChinh(text, record, strMonth, setIsShowEditPhep, setDataDetailPhep)
                },
                {
                    title: "Còn lại",
                    dataIndex: "conlai" + strMonth,
                    key: "conlai" + strMonth,
                    align:'center',
                    className:'hoverBlur',
                    filterKey: 'conlai' + strMonth,
                    type: 'text',
                    width:80,
                },
            ]
            result.push(obj)
        }
        return result
    }

    const mapData = (values,date)=>{
        let arrData = [];
        for (let iUser of values){
            let obj = {};
            obj.username = iUser.msnv + '-' + iUser.username;
            obj.userId = iUser.userId;
            obj.phepcu = iUser.phepcu;
            obj.thamnien = iUser.thamnien;
            obj.phepnam = iUser.phepnam;
            for (let i of iUser.data){
                obj['cap' + i.thang] = i.cap
                obj['dung' + i.thang] = i.dung
                obj['dieuchinh' + i.thang] = i.dieuchinh
                obj['conlai' + i.thang] = i.conlai
                obj['statusid' + i.thang] = i.TrangthaiId
                obj['id' + i.thang] = i.id
                obj['trangthai' + i.thang] = i.trangthai
                if (i.thang === date.format("MMYYYY")){
                    obj.trangthai = i.trangthai
                    obj.ghichu = i.ghichu
                }
            }
            arrData.push(obj);
        }
        return arrData
    }

    const fetchData = (params = {})=>{
        setLoading(true);
        ListBangPhepQLApi({
            idTeam:params.idTeam,
            thoiGian:params.thoiGian,
            page:params.current,
            page_size:params.pageSize,
            search: params.search
        }).then(r=>{
            setData(mapData(r.data.results,params.date || currentSelectedDate));
            setPager({
                current: params.current,
                pageSize: params.pageSize,
                count: r.data.count
            });
            setLoading(false);
        })
        .catch(err=>{
            errorHandle(err);
            setLoading(false);
        })
        setColumnFinal([...columns_first(params.date || currentSelectedDate),...columnsMonth(params.date || currentSelectedDate),...columns_last]);
    }

    useEffect(()=>{
        if (currentSelectedDate && currentTeam.length > 0){
            fetchData({date:currentSelectedDate, idTeam:JSON.stringify(currentTeam),thoiGian:currentSelectedDate.format("YYYYMM"),
            ...pager});
        }
        if (currentTeam.length === 0) {
            setData([]);
        }
    },[currentSelectedDate, currentTeam])
    
    
    const fetchListTeam = () =>{
        ListBoPhanApi().then(res=>{
            const arrTeam = userInfo.team_permissions.filter(item=>item.phanquyen__ten_pq === 'is_leave_date_xx')
                                                        .map((item,index)=>{
                                                            const idBoPhanForTeam = res.data.filter(itemBP =>  itemBP.team.some(itemT => itemT.id==item.team) )
                                                            if (idBoPhanForTeam.length != 0){
                                                                return {idTeam:item.team, team:item.team__tenTeam, idBoPhan: idBoPhanForTeam[0].id}
                                                            }
                                                            return false
                                                        }).filter(item => item != false);
            const uniqueArrTeam = [...new Map(arrTeam.map(item =>[item['idTeam'], item])).values()]
            uniqueArrTeam.sort(function(first, second) {
                return first['idTeam'] - second['idTeam'] ;
              });
            const arrIdTeam = uniqueArrTeam.map(item=>item.idTeam);
            const arrBoPhan = res.data.filter(({team}) => team.some(item => arrIdTeam.includes(item.id)) )
            // const arrBoPhan = res.data.filter(itemBP => itemBP.team.map(item=>item.id).filter(x => arrIdTeam.includes(x)))
            if (arrBoPhan.length > 0) {
                setCurrentBoPhan([arrBoPhan[0].id]);
            }
            setLsBoPhan(arrBoPhan);

            setLsAllTeam(uniqueArrTeam);
            if (currentTeam.length === 0){
                setCurrentTeam([arrIdTeam.filter(x => arrBoPhan[0].team.map(item=>item.id).includes(x))[0]]); // 200423 lấy element đầu tiên đặt trong list
                // setCurrentTeam(arrIdTeam.filter(x => arrBoPhan[0].team.map(item=>item.id).includes(x)));
            }
            setLsTeam(uniqueArrTeam.filter(x => arrBoPhan[0].team.map(item=>item.id).includes(x.idTeam)) );
            
        });
    }

    useEffect(()=>{
        if (userInfo && userInfo.team_permissions && userInfo.team_permissions.length > 0){
            fetchListTeam();
        }
    },[userInfo])

    const updateData=()=>{
        fetchData({
            idTeam:JSON.stringify(currentTeam),
            thoiGian:moment(currentSelectedDate).format("YYYYMM"),
            ...pager
        })
    }

    const onChangeBoPhan =(value)=>{
        if (value.length > 0) {
            setCurrentBoPhan(value);
            const lsTeamWith_BP = lsAllTeam.filter(x => value.includes(x.idBoPhan))
            setLsTeam(lsTeamWith_BP);
            setCurrentTeam([lsTeamWith_BP.map(item=>item.idTeam)[0]]); // 200423
            // setCurrentTeam(lsTeamWith_BP.map(item=>item.idTeam));
        } else {
            setLsTeam([]);
            setCurrentBoPhan([]);
            setCurrentTeam([]);
        };
    }

    const tPropsConfig_BoPhan = {
        treeData:[{
            title:
                currentBoPhan.length > 0 ? (
                <span
                  onClick={() => {if (!loading){onChangeBoPhan([])}}}
                  className="style_SelectTeam"
                >
                  Bỏ chọn tất cả
                </span>
              ) : (
                <span
                  onClick={() => {if (!loading) {onChangeBoPhan(lsBoPhan.map(item=>item.id))}}}
                  className="style_SelectTeam"
                >
                  Chọn tất cả
                </span>
              ),
            value: "xxx",
            disableCheckbox: true,
            disabled: true,
            className: "style_treeTeam"
          },...treeDataBoPhan],
        value: treeDataBoPhan.length > 0 ? currentBoPhan : undefined,
          onChange:onChangeBoPhan,
        treeCheckable: true,
        // showCheckedStrategy: SHOW_PARENT,
          maxTagCount:2,
        placeholder: 'Chọn bộ phận',
        style:{width:'fit-content',minWidth:200},
      };

    useEffect(()=>{
        const treeDataBoPhan = lsBoPhan.map(item=>{return {title: item.tenBophan, value: item.id, key: item.id}})
        setTreeDataBoPhan(treeDataBoPhan);
        if (currentBoPhan.length === 0){
            setCurrentBoPhan(lsBoPhan.map(item=>item.id));
        };
    },[lsBoPhan])

    const onChangeTeam =(value)=>{
        if (loading){
            return
        }
        if (value.length > 0) {
            setCurrentTeam(value);
            // fetchData({idTeam:JSON.stringify(value),thoiGian:moment(new Date(currentSelectedDate)).format("YYYYMM")})
        } else {
            setCurrentTeam([]);
            setData([])
        };
    }

    const tPropsConfig = {
        treeData:[{
            title:
              currentTeam.length > 0 ? (
                <span
                  onClick={() => {if (!loading){setCurrentTeam([])}}}
                  className="style_SelectTeam"
                >
                  Bỏ chọn tất cả
                </span>
              ) : (
                <span
                  onClick={() => {if (!loading) {setCurrentTeam(lsTeam.map(item=>item.idTeam))}}}
                  className="style_SelectTeam"
                >
                  Chọn tất cả
                </span>
              ),
            value: "xxx",
            disableCheckbox: true,
            disabled: true,
            className: "style_treeTeam"
          },...treeData],
        value: treeData.length > 0 ? currentTeam : undefined,
          onChange:onChangeTeam,
        treeCheckable: true,
        // showCheckedStrategy: SHOW_PARENT,
          maxTagCount:2,
        placeholder: 'Chọn team',
        style:{width:'fit-content',minWidth:200},
      };

    useEffect(()=>{
        const treeDataTemp = lsTeam.map(item=>{return {title: item.team, value: item.idTeam, key: item.idTeam}})
        setTreeData(treeDataTemp);
        // setCurrentTeam(lsTeam.map(item=>item.idTeam));
        if (currentTeam.length === 0){
            setCurrentTeam(lsTeam.map(item=>item.idTeam));
        };
    },[lsTeam])

    // const getDateRange = (date) =>{
    //     const current = date._d.getDay() === 0 ? 7 : date._d.getDay();
    //     const firstDay = new Date(new Date(date).getTime()-((current-1)*24*60*60*1000));
    //     const endDay = new Date(new Date(firstDay).getTime()+(6*24*60*60*1000));
    //     return getDaysArray(firstDay, endDay);
    // };

    const onChangeMonth =(date)=>{
        setCurrentSelectedDate(date)
        // fetchData({date:date,idTeam:JSON.stringify(currentTeam),thoiGian:moment(date).format("YYYYMM")})
    };

    // const onQuickChangeWeek=(type)=>{
    //     const numberDay = type === 'previous' ? -7 : 7;
    //     const newFirstDate = new Date(new Date(lsDate[0]).getTime()+((numberDay)*24*60*60*1000));
    //     const lsDateTemp = getDateRange(moment(newFirstDate));
    //     setCurrentSelectedDate(moment(newFirstDate));
    //     setLsDate(lsDateTemp);
    //     fetchData({idTeam:JSON.stringify(currentTeam),thoiGian:moment(new Date(currentSelectedDate)).format("YYYYMM")})
    // }
    const onQuickChangeMonth=(type)=>{
        let monthChange;
        if (type === 'previous'){
            monthChange = moment(currentSelectedDate).subtract(1, 'month');
        } else {
            monthChange = moment(currentSelectedDate).add(1, 'month');
        }
        setCurrentSelectedDate(monthChange);
        // fetchData({date:monthChange ,idTeam:JSON.stringify(currentTeam),thoiGian:moment(monthChange).format("YYYYMM")})
    }

    const handleChange =(pagination)=>{
        const currentPager = {...pager};
        currentPager.current = pagination.current;
        currentPager.pageSize = pagination.pageSize;
        setPager({...currentPager});
        fetchData({
            idTeam:JSON.stringify(currentTeam),
            thoiGian:moment(currentSelectedDate).format("YYYYMM"),
            status:currentPager.status,
            pageSize:pagination.pageSize,
            current:pagination.current,
            search
        })

    }

    // const onDuyetPhep =()=>{
    //     duyetPhepTeamApi({
    //         idTeam: JSON.stringify(currentTeam),
    //         thoiGian: moment(new Date(currentSelectedDate)).format("YYYYMM")
    //     })
    //         .then(r=>{
    //             openNotificationWithIcon('success','Thành công','')
    //             updateData();
    //         })
    //         .catch(err=>{
    //             errorHandle(err)
    //         })
    // }

    // const onKhaiBaoPhep =()=>{
    //     console.log(lsTeam)
    //     console.log(currentSelectedDate)
    //     setIsShowKhaiBaoPhep(true)

    // }
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0 font-size-18">Bảng phép</h4>
                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><Link href="#">Quản lý</Link>
                                </li>
                                <li className="breadcrumb-item active">Bảng phép</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className={'col-12 mb-2 d-sm-flex align-items-center justify-content-between'}>
                    <div className={'col'}>
                        <Button type="primary" className={'m-2 styleNtn_1'} onClick={()=>onQuickChangeMonth('previous')} title="Tuần trước">
                            <i className={'fa fa-arrow-left'}></i>
                        </Button>
                        {new Date(currentSelectedDate).getTime() < new Date(new Date().getFullYear(), new Date().getMonth(), 1).getTime() &&
                        <Button type="primary" className={'m-2 styleNtn_1'} onClick={()=>onQuickChangeMonth('next')} title="Tháng sau">
                            <i className={'fa fa-arrow-right'}></i>
                        </Button>}
                        <DatePicker 
                            style={{borderRadius:10}} 
                            className={'m-2'} 
                            onChange={onChangeMonth} picker={'month'} 
                            value={currentSelectedDate} 
                            format={'MM/YYYY'}
                             disabled={loading}
                            allowClear={false}
                            disabledDate={disabledMonth}
                        />

                        <div className="styleBadge">
                            <Badge.Ribbon text="Bộ phận" color="gray" style={{color:"red"}}>
                                <TreeSelect {...tPropsConfig_BoPhan} />
                            </Badge.Ribbon>
                        </div>
                        <div className="styleBadge">
                            <Badge.Ribbon text="Team" color="gray" style={{color:"red"}}>
                                <TreeSelect {...tPropsConfig} />
                            </Badge.Ribbon>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <Table
                    dataSource={data}
                    columns={columnFinal}
                    loading={loading}
                    className={'custom-table-hover style-6'}
                    bordered={true}
                    size={'small'}
                    rowKey="id"
                    scroll={{y:500}}
                    onChange={handleChange}
                    pagination={{
                        current: pager.current,
                        pageSize: pager.pageSize,
                        total: pager.count,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        pageSizeOptions: ['50', '75', '100']
                    
                    }}
                    // pagination={false}

                />
                <ModalEditPhep
                    visible={isShowEditPhep}
                    onCancel={()=>setIsShowEditPhep(false)}
                    updateData={updateData}
                    dataDetailPhep={dataDetailPhep}
                />
                <ModalKhaiBaoPhep
                    visible={isShowKhaiBaoPhep}
                    onCancel={()=>setIsShowKhaiBaoPhep(false)}
                    updateData={updateData}
                />

            </div>
        </>
    )
}